import {
    SET_COUNTRY_SETTINGS,
    SET_PREVIOUS_LOCATION,
} from '../actions/actionTypes';

const INITIAL_STATE = {
    countryTitle: 'Česká republika',
    languagePickerTitle: 'Česko / Kč',
    currency: 'CZK',
    country: 'CZ',
    locale: 'cs',
    isCountrySet: false,
    previousLocation: null,
    localeStrings: null
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {

        case SET_COUNTRY_SETTINGS + '_FULFILLED':
            return { ...state, ...action.payload, isCountrySet: true };

        case SET_PREVIOUS_LOCATION:
            return { ...state, previousLocation: action.payload };

        default:
            return state;
    }
}
